export const getInitialState = ({ organizationName }) => ({ organizationName });
